import React, { useState } from 'react';
import { login } from '../services/api';
import { useNavigate } from 'react-router-dom';

function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [statusCode, setStatusCode] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setStatusCode(null);
    setLoading(true);

    try {
      const res = await login({ email, password });

      if (Object.keys(res.data).length > 0) {
        localStorage.setItem('access_token', res.data.access_token);
        localStorage.setItem('name', res.data.name);
        localStorage.setItem('is_admin', res.data.is_admin);

        setTimeout(() => {
          navigate(res.data.is_admin ? '/admin/users' : '/home');
        }, 1000);
      } else {
        setMessage(res.message);
        setStatusCode(res.status_code || 200);
        setLoading(false);
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Login failed';
      const errorStatus = err.response?.status || 400;
      setMessage(errorMessage);
      setStatusCode(errorStatus);
      setLoading(false);
    }
  };

  return (
    <>
  <h2 className="text-center mb-4" style={{ marginTop: '18px' }}>Inloggen</h2>

      {message && (
        <div className={`alert ${statusCode === 200 ? 'alert-success' : 'alert-danger'}`} role="alert" style={{ fontSize: '0.95rem', padding: '8px 12px' }}>
          {message}
        </div>
      )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3" style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '360px' }}>
              <label htmlFor="email" style={{ color: '#9E9E9E', fontWeight: 500, fontSize: '0.82rem', marginBottom: '0.18rem', display: 'block' }}>E-mailadres</label>
              <input
                id="email"
                type="email"
                className="form-control custom-placeholder"
                style={{ borderRadius: '12px', fontSize: '0.95rem', padding: '12px 12px', height: '48px' }}
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="mb-3" style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '360px' }}>
              <label htmlFor="password" style={{ color: '#9E9E9E', fontWeight: 500, fontSize: '0.82rem', marginBottom: '0.18rem', display: 'block' }}>Wachtwoord</label>
              <input
                id="password"
                type="password"
                className="form-control custom-placeholder"
                style={{ borderRadius: '12px', fontSize: '0.95rem', padding: '12px 12px', height: '48px' }}
                placeholder="Wachtwoord"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button
              type="submit"
              className="btn fw-bold"
              style={{ backgroundColor: '#A3E2A8', color: '#222', borderRadius: '24px', height: '44px', fontWeight: 600, fontSize: '1.08rem', marginTop: '18px', width: '360px' }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Logging in...
                </>
              ) : (
                'Inloggen'
              )}
            </button>
          </div>
          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <a href="#" style={{ color: '#5865F2', fontSize: '0.98rem', textDecoration: 'underline', fontWeight: 'bold' }}>Wachtwoord vergeten?</a>
          </div>

          {/* Divider */}
          <div style={{ width: '360px', height: '1px', background: '#F0EBE8', margin: '32px auto 18px auto' }} />

          {/* Info text */}
          <div style={{ textAlign: 'center', fontSize: '0.98rem', color: '#6A7583', maxWidth: '360px', margin: '0 auto' }}>
            Ben je energieadviseur en wil je gebruik maken van het platform, neem dan{' '}
            <a
              href="https://www.ep-scan.nl/contact"
              style={{ textDecoration: 'underline', color: '#6A7583', fontWeight: 500 }}
              target="_blank"
              rel="noopener noreferrer"
            >
              contact op
            </a>.
          </div>
      </form>
    </>
  );
}

export default LoginForm;
